// src/utils/analyticsConsent.js

const KEY = "xlz_analytics_consent"; // "granted" | "denied" | null

export function getStoredAnalyticsConsent() {
  try {
    const v = localStorage.getItem(KEY);
    return v === "granted" || v === "denied" ? v : null;
  } catch {
    return null;
  }
}

export function storeAnalyticsConsent(value) {
  try {
    localStorage.setItem(KEY, value);
  } catch {
    // ignore
  }
}

function ensureGtag() {
  return typeof window !== "undefined" && typeof window.gtag === "function";
}

/**
 * Set your baseline consent state for this page load.
 * We default to analytics ON (granted) unless the user has opted out previously.
 */
export function applyConsentDefaults() {
  const stored = getStoredAnalyticsConsent();

  const analytics_storage = stored === "denied" ? "denied" : "granted";

  if (!ensureGtag()) return { analytics_storage, stored };

  // Consent Mode v2 fields. Ads remain denied always in this model.
  window.gtag("consent", "default", {
    analytics_storage,
    ad_storage: "denied",
    ad_user_data: "denied",
    ad_personalization: "denied",
  });

  return { analytics_storage, stored };
}

/**
 * User actively opts OUT (deny) or opts IN (grant).
 */
export function updateAnalyticsConsent(value /* "granted" | "denied" */) {
  if (value !== "granted" && value !== "denied") return;

  storeAnalyticsConsent(value);

  if (!ensureGtag()) return;

  window.gtag("consent", "update", {
    analytics_storage: value,
    // Keep ads denied regardless
    ad_storage: "denied",
    ad_user_data: "denied",
    ad_personalization: "denied",
  });
}

/**
 * Optional: let the user re-open the banner by clearing the stored choice.
 */
export function resetAnalyticsConsentChoice() {
  try {
    localStorage.removeItem(KEY);
  } catch {
    // ignore
  }
}
